import PropTypes from 'prop-types';

import { Flex, Heading, CaretRightIcon as PlasticCaretRightIcon } from '@cof/plastic-components';
import { css, styled } from 'styled-components';

export const CaretRightIcon = styled(PlasticCaretRightIcon)`
    ${({ theme }: any) => css`
        height: 2.2rem;
        width: 1.4rem;
        margin-right: 1.2rem;
        color: ${theme.colors.capitalOne.teal600};

        ${theme.breakpoints.mq.tabletMin} {
            height: 2.6rem;
            width: 1.4rem;
        }
        flex-shrink: 0;

        ${theme.components.CaretRightIcon};
    `}
`;
CaretRightIcon.displayName = 'CaretRightIcon';

export const StyledNarrativeHeading = styled(Heading)`
    ${({ theme }: any) => css`
        font-weight: ${theme.fontWeights.regular};
        font-family: ${theme.fonts.body};
        padding-bottom: ${theme.space.xs};
        text-align: left;
        line-height: 1.3;
        ${theme.components.NarrativeText}
        font-size: ${theme.fontSizes.textLargeMobile};
        ${theme.breakpoints.mq.tabletMin} {
            line-height: 1.4;
            font-size: ${theme.fontSizes.textMediumDesktop};
        }
    `}
`;

export const NarrativeTextHookForm = ({ children, ...props }: any) => {
    return (
        <>
            <Flex {...props}>
                <CaretRightIcon data-qa-id="caret-right-icon" />
                <StyledNarrativeHeading data-qa-id="narrative-text" level="2" data-qm-allow>
                    {children}
                </StyledNarrativeHeading>
            </Flex>
        </>
    );
};

NarrativeTextHookForm.propTypes = {
    children: PropTypes.node.isRequired
};
